/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PersonalAssetHistoryWithCumulativeDto,
    PersonalAssetHistoryWithCumulativeDtoFromJSON,
    PersonalAssetHistoryWithCumulativeDtoFromJSONTyped,
    PersonalAssetHistoryWithCumulativeDtoToJSON,
} from './PersonalAssetHistoryWithCumulativeDto';

/**
 * 
 * @export
 * @interface PersonalAssetHistoryListDto
 */
export interface PersonalAssetHistoryListDto {
    /**
     * 
     * @type {number}
     * @memberof PersonalAssetHistoryListDto
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof PersonalAssetHistoryListDto
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof PersonalAssetHistoryListDto
     */
    offset: number;
    /**
     * 
     * @type {Array<PersonalAssetHistoryWithCumulativeDto>}
     * @memberof PersonalAssetHistoryListDto
     */
    items: Array<PersonalAssetHistoryWithCumulativeDto>;
}

export function PersonalAssetHistoryListDtoFromJSON(json: any): PersonalAssetHistoryListDto {
    return PersonalAssetHistoryListDtoFromJSONTyped(json, false);
}

export function PersonalAssetHistoryListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonalAssetHistoryListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'limit': json['limit'],
        'offset': json['offset'],
        'items': ((json['items'] as Array<any>).map(PersonalAssetHistoryWithCumulativeDtoFromJSON)),
    };
}

export function PersonalAssetHistoryListDtoToJSON(value?: PersonalAssetHistoryListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'limit': value.limit,
        'offset': value.offset,
        'items': ((value.items as Array<any>).map(PersonalAssetHistoryWithCumulativeDtoToJSON)),
    };
}

